// removed by extract-text-webpack-plugin
module.exports = {"Backdrop":"Backdrop__Backdrop__efy1y"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Backdrop/Backdrop.css
// module id = 130
// module chunks = 3